import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import { ActiveTab } from '@/components/prine/enums/ActiveTab';
import type { Tag } from '@/models/tag';

Vue.use(Vuex);

interface State {
    activeTab: ActiveTab;
    showEmptyTopics: boolean;
    showEmptyTrades: boolean;
    showEmptySubphases: boolean;
    showEmptyXSubProcesses: boolean;
    tradesActivePhaseTabIndex: number;
    conceptsActivePhaseTabIndex: number;
    tradeSearchString: string;
    pmSearchString: string;
    xSearchString: string;
    tradeSelectedTag: Tag | null;
    pmSelectedTag: Tag | null;
    xSelectedTag: Tag | null;
}

const mutations: MutationTree<State> = {
    setActiveTab(currentState, activeTab: ActiveTab) {
        currentState.activeTab = activeTab;
    },
    setTradesActivePhaseTabIndex(currentState, index: number) {
        currentState.tradesActivePhaseTabIndex = index;
    },
    setConceptsActivePhaseTabIndex(currentState, index: number) {
        currentState.conceptsActivePhaseTabIndex = index;
    },
    setShowEmptyTopics(currentState, value: boolean) {
        currentState.showEmptyTopics = value;
    },
    setShowEmptyTrades(currentState, value: boolean) {
        currentState.showEmptyTrades = value;
    },
    setShowEmptySubphases(currentState, value: boolean) {
        currentState.showEmptySubphases = value;
    },
    setShowEmptyXSubProcesses(currentState, value: boolean) {
        currentState.showEmptyXSubProcesses = value;
    },
    setTradeSearchString(currentState: State, value: string) {
        currentState.tradeSearchString = value;
    },
    setPmSearchString(currentState: State, value: string) {
        currentState.pmSearchString = value;
    },
    setXSearchString(currentState: State, value: string) {
        currentState.xSearchString = value;
    },
    setTradeSelectedTag(currentState: State, value: Tag | null) {
        currentState.tradeSelectedTag = value;
    },
    setPmSelectedTag(currentState: State, value: Tag | null) {
        currentState.pmSelectedTag = value;
    },
    setXSelectedTag(currentState: State, value: Tag | null) {
        currentState.xSelectedTag = value;
    },
    clearSearchStrings(currentState: State) {
        currentState.tradeSearchString = '';
        currentState.pmSearchString = '';
        currentState.xSearchString = '';
    },
    resetState() {
        // console.log('resetState FIRED FROM Account STORE');
        // acquire initial state
        const s = initialState();

        Object.keys(s).forEach((key) => {
            state[key] = s[key];
        });
    },
};

const actions: ActionTree<State, any> = {};

const getters = {
    activeTab(currentState: State): ActiveTab {
        return currentState.activeTab;
    },
    tradesActivePhaseTabIndex(currentState: State): number {
        return currentState.tradesActivePhaseTabIndex;
    },
    conceptsActivePhaseTabIndex(currentState: State): number {
        return currentState.conceptsActivePhaseTabIndex;
    },
    showEmptyTopics(currentState: State): boolean {
        return currentState.showEmptyTopics;
    },
    showEmptyTrades(currentState: State): boolean {
        return currentState.showEmptyTrades;
    },
    showEmptySubphases(currentState: State): boolean {
        return currentState.showEmptySubphases;
    },
    showEmptyXSubProcesses(currentState: State): boolean {
        return currentState.showEmptyXSubProcesses;
    },
    tradeSearchString(currentState: State): string {
        return currentState.tradeSearchString;
    },
    pmSearchString(currentState: State): string {
        return currentState.pmSearchString;
    },
    xSearchString(currentState: State): string {
        return currentState.xSearchString;
    },
    tradeSelectedTag(currentState: State): Tag | null {
        return currentState.tradeSelectedTag;
    },
    pmSelectedTag(currentState: State): Tag | null {
        return currentState.pmSelectedTag;
    },
    xSelectedTag(currentState: State): Tag | null {
        return currentState.xSelectedTag;
    },
};

function initialState() {
    return {
        activeTab: ActiveTab.trade,
        showEmptyTopics: false,
        showEmptySubphases: false,
        showEmptyXSubProcesses: false,
        showEmptyTrades: false,
        tradesActivePhaseTabIndex: 0,
        conceptsActivePhaseTabIndex: 0,
        tradeSearchString: '',
        pmSearchString: '',
        xSearchString: '',
        tradeSelectedTag: null,
        pmSelectedTag: null,
        xSelectedTag: null,
    } as State;
}

const state: State = initialState();

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
